import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Link, useLocation, useParams } from 'react-router-dom';
import logo from '../../assets/img/logo.png';
// import HODL from '../../assets/img/HODL.png';
import HODLX from '../../assets/img/HODLX.png';
// import ShiftIcon from '../../assets/img/shift.png';
import { Button } from '@material-ui/core';
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  ListItem,
  Divider,
  Grid,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { 
  makeStyles, 
  // useTheme 
} from '@material-ui/core/styles';
import useTokenBalance from '../../hooks/useTokenBalance';
import useTombFinance from '../../hooks/useTombFinance';
import { getDisplayBalance } from '../../utils/formatBalance';
import AccountButton from './AccountButton';
import AccountButtonNav from './AccountButtonNav';
import Spacer from '../Spacer';
import styled from 'styled-components';

const menuLinks = [
  {
    id: 1,
    name: 'Rangefinder',
    path: '/rangefinder',
  },
  {
    id: 2,
    name: 'Coin Toss',
    path: '/coin-toss',
  },
];
const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  appBar: {
    width: '100%',
    color: '#e0e3bd',
    'background-color': 'transparent',
    // borderBottom: `1px solid ${theme.palette.divider}`,
    padding: '10px',
    marginBottom: '25px',
    [theme.breakpoints.up('md')]: {
      marginBottom: '60px',
    },
  },
  active: {
    color: '#0098ff',
    textTransform: 'capitalize',
    margin: theme.spacing(1, 2),
    textDecoration: 'none',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  activeSpider: {
    position: 'absolute',
    top: '50px',
    left: 0,
    right: 0,
    margin: 'auto',
  },
  tokenPrice: {
    paddingTop: '16px',
    paddingLeft: '20px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'white',
  },
  activeSmallSpider: {
    position: 'absolute',
    top: '0',
    right: '10px',
    bottom: 0,
    margin: 'auto',
    // width: "100%",
  },
  box: {
    flexGrow: 1,
  },
  drawer: {
    width: 240,
    flexShrink: 0,
  },
  drawerPaper: {
    width: '80%',
    backgroundSize: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: ' left bottom',
    backgroundColor: '#757575',
    // backgroundImage: `url(${mobileGhost})`,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    fontFamily: '"Amarante", cursive',
    fontSize: '30px',
    // flexGrow: 1,
  },
  link: {
    // fontSize: "16px",
    color: '#EEE',
    textTransform: 'capitalize',
    fontSize: '16px',
    margin: '0 20px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
      color: '#fff',
    },
    '&:focus': {
      color: '#fff',
    },
  },
  mobileLink: {
    color: '#EEE',
    textTransform: 'capitalize',
    fontSize: '16px',
    fontWeight: 500,
    textDecoration: 'none',
    padding: '6px',
    '&:hover': {
      textDecoration: 'none',
      color: '#fff',
    },
    '&:focus': {
      color: '#fff',
    },
  },
  brandLink: {
    textDecoration: 'none',
    color: '#e0e3bd',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  resLogo: {
    padding: '20px',
    display: 'grid',
    // placeItems: 'center',
    textDecoration: 'none',
    color: '#e0e3bd',
    '&:hover': {
      textDecoration: 'none',
    },
    // placeItems: "center",
  },
  blackBg: {
    border: 'none',
    borderRadius: '10px!important',
    backgroundColor: '#75757530',
    padding: '6px 10px',
    color: 'white!important',
    height: '46px',
    marginRight: '10px',
    fontFamily: "'Chillax', sans-serif !important",
    fontSize: '16px',
  },
  blackBgActive: {
    backgroundColor: '#757575',
  },
  blackBgNav: {
    backgroundColor: 'rgba(255, 255, 255, 0.09);',
    border: 'none',
    borderRadius: '10px!important',
    padding: '6px 10px ',
    margin: '10px 20px',
    color: 'white!important',
    height: '46px',
    fontFamily: "'Chillax', sans-serif !important",
    fontSize: '16px',
    width: '100%',
    justifyContent: 'space-between',
  },
  blackBgNavActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.3);',
  },
  img: {
    width: '24px',
    height: '24px',
  },
  dotmenuitem: {
    marginRight: '14px',
    fontSize: '20px',
    color: '#FFF',
    marginBottom: '-4px',
    '&:hover': {
      background: 'rgb(49 34 86 / 0%) !important',
    }
  }
}));

export const ResItemRight = styled.div``;
interface props {
  height: number;
}


const Nav = () => {
  const matches = useMediaQuery('(min-width:1080px)');
  const tombFinance = useTombFinance();
  const { tokenName_ } = useParams();
  const tokenName = tokenName_ === `hodlx` ? `HODLX` : `HODL`;
  const classes = useStyles();
  // const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const { pathname } = useLocation();

  const tshareBalance = useTokenBalance(tombFinance.externalTokens['HODLX']);
  const displayTshareBalance = useMemo(() => getDisplayBalance(tshareBalance, tombFinance.externalTokens['HODLX'].decimal, 0), [tshareBalance, tombFinance.externalTokens]);

  // const tombBalance = useTokenBalance(tombFinance.externalTokens['HODL']);
  // const displayTombBalance = useMemo(() => getDisplayBalance(tombBalance, tombFinance.externalTokens['HODL'].decimal, 0), [tombBalance, tombFinance.externalTokens]);

  return (
    <AppBar position="static" elevation={0} className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        {matches ? (
          <>
            <Typography variant="h6" color="inherit" noWrap className={classes.toolbarTitle}>
              {/* <a className={ classes.brandLink } href="/">Tomb Finance</a> */}
              <Link to="/" color="inherit" className={classes.brandLink}>
                <img alt='' src={logo} width="200px" height="60px" />
              </Link>
            </Typography>
            <Box className={classes.box}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div style={{ display: 'flex' }}>
                  {menuLinks.map(
                    ({ name, path, id }) =>
                      id < 8 && (
                        <div style={{ position: 'relative' }}>
                          <Link
                            color="textPrimary"
                            to={path}
                            className={pathname.includes(path) ? classes.active : classes.link}
                          >
                            {name}
                          </Link>
                        </div>
                      ),
                  )}
                  {/* <div style={{ position: 'relative' }}>
                    <a className={classes.link} target="_blank" rel="noopener noreferrer" href='https://hodlx.exchange/swap?outputCurrency=0x0E9766dF73973abCfEDDE700497c57110ee5c301'>Buy HODL</a>
                  </div> */}
                  <div style={{ position: 'relative' }}>
                    <a className={classes.link} target="_blank" rel="noopener noreferrer" href='https://hodlx.exchange/swap?outputCurrency=0xAeBdbcc7d6821E3924EE5167b4138a43c19Cf681'>Buy HODLX</a>
                  </div>
                </div>
                <Grid container className="price-buttons">
                  {/* <Button className={`${classes.blackBg} ${tokenName === "HODL" ? classes.blackBgActive : ''}`} component={Link} to={`/${pathname.includes('rangefinder') ? `rangefinder` : `coin-toss`}/hodl`}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img alt='' src={HODL} width="30px" />
                      &nbsp;&nbsp;
                      <span>{displayTombBalance}</span>
                    </div>
                  </Button>
                  <img src={ShiftIcon} alt="" width="24px" height="28px" style={{ alignSelf: 'center', marginRight: "8px" }} /> */}
                  <Button className={`${classes.blackBg} ${tokenName === "HODLX" ? classes.blackBgActive : ''}`} component={Link} to={`/${pathname.includes('rangefinder') ? `rangefinder` : `coin-toss`}/hodlx`}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img alt='' src={HODLX} width="30px" />
                      &nbsp;&nbsp;
                      <span>{displayTshareBalance}</span>
                    </div>
                  </Button>
                </Grid>
              </div>
            </Box>
            <AccountButton text="Connect Wallet" />
          </>
        ) : (
          <>
            <IconButton
              color="secondary"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap style={{ width: '100%', textAlign: "center", marginTop: '-3rem' }}>
              <Link to="/" color="inherit" className={classes.brandLink}>
                <img alt='' src={logo} width="140px" />
              </Link>
            </Typography>

            <Drawer
              className={classes.drawer}
              onEscapeKeyDown={handleDrawerClose}
              onBackdropClick={handleDrawerClose}
              variant="temporary"
              anchor="left"
              open={open}
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <div style={{position: 'absolute', right: '1.25rem', top: '1.25rem'}}>
                <Button className='dismiss-button' onClick={handleDrawerClose} />
              </div>
              <Link to="/" color="inherit" className={classes.resLogo}>
                <img alt='' src={logo} width="140px" />
              </Link>
              <ListItem
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <AccountButtonNav text="Connect wallet" />
              </ListItem>
              <Spacer />

              {menuLinks.map(({ path, name }) => (
                <div style={{ padding: '10px 0px', position: 'relative' }}>
                  <Link
                    color="textPrimary"
                    to={path}
                    style={{ fontSize: '16px' }}
                    className={pathname.includes(path) ? classes.active : classes.link}
                  >
                    {name}
                  </Link>
                </div>
              ))}
              {/* <div style={{ padding: '10px 0px', position: 'relative' }}>
                <a className={classes.link} target="_blank" rel="noopener noreferrer" href='https://hodlx.exchange/swap?outputCurrency=0x0E9766dF73973abCfEDDE700497c57110ee5c301'>Buy HODL</a>
              </div> */}
              <div style={{ padding: '10px 0px', position: 'relative' }}>
                <a className={classes.link} target="_blank" rel="noopener noreferrer" href='https://hodlx.exchange/swap?outputCurrency=0xAeBdbcc7d6821E3924EE5167b4138a43c19Cf681'>Buy HODLX</a>
              </div>

              <Divider />
              <div className={classes.tokenPrice}>Selected Token</div>
              {/* <ListItem
                style={{
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'center',
                  width: '100%',
                  padding: '0px 0px',
                }}
              >
                <Button className={`${classes.blackBgNav} ${tokenName === "HODL" ? classes.blackBgNavActive : ''}`} component={Link} to={`/${pathname.includes('rangefinder') ? `rangefinder` : `coin-toss`}/hodl`}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img alt='' src={HODL} width="36px" />
                    &nbsp;&nbsp;
                    <span>{displayTombBalance}</span>
                  </div>
                </Button>
              </ListItem> */}
              {/* <ListItem
                style={{
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'center',
                  width: '100%',
                  padding: '0px 0px',
                }}
              >
                <img src={ShiftIcon} alt="" width="24px" height="28px" style={{ alignSelf: 'center' }} />
              </ListItem> */}
              <ListItem
                style={{
                  display: 'flex',
                  alignItems: 'left',
                  justifyContent: 'center',
                  padding: '0px 0px',
                }}
              >
                <Button className={`${classes.blackBgNav} ${tokenName === "HODLX" ? classes.blackBgNavActive : ''}`} component={Link} to={`/${pathname.includes('rangefinder') ? `rangefinder` : `coin-toss`}/hodlx`}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img alt='' src={HODLX} width="36px" />
                    &nbsp;&nbsp;
                    <span>{displayTshareBalance}</span>
                  </div>
                </Button>
              </ListItem>
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};
export default Nav;
